/**
 * @ngdoc services
 * @memberof mercury.modules.stock
 * @name StockItemGroups
 */
angular.module('mercury.modules.stock.item')
.factory('StockItemGroups', ["$resource", "settings", function($resource, settings) {
  var StockItemGroups = $resource(settings.apiHost + '/r/StockItemGroups');
  var ItemSubcategories = $resource(settings.stockHost + '/internal/subcategories')

  /**
   * [getAll description]
   *
   * @memberof StockItemGroups
   * @return {?} [description]
   */
  function getAll() {
    return StockItemGroups.query();
  }

  /**
   * Gets all item subcategories (item groups)
   * @returns all items subcategories
   */
  const getAllSubcategories = () => ItemSubcategories.query() 

  return {
    getAll: getAll,
    getAllSubcategories
  };
}]);
